import { render, staticRenderFns } from "./CompaniesFilter.vue?vue&type=template&id=2b29ad9e&"
import script from "./CompaniesFilter.vue?vue&type=script&lang=js&"
export * from "./CompaniesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports